export class User {
  id = 0;
  username = "";
  email = "";
  firstName = "";
  lastName = "";
  confirmed = false;
  password? = "placeholder";
  token = "";
  role: any = {};
  billingAddress = "";
  feedbackMailStatus = "";
  lastFeedbackMailSentAt = "";

  get displayName(): string {
    return this.firstName.trim() || this.username;
  }

  parseJson(ret: { [key: string]: any }) {
    if (ret) {
      this.id = ret.id;
      if (ret.attributes) {
        this.username = ret.attributes.username;
        this.email = ret.attributes.email;
        this.confirmed = ret.attributes.confirmed;
        this.billingAddress = ret.attributes.billingAddress ?? "";
        this.role = ret.attributes.role;
        this.firstName = ret.attributes.firstName ?? "";
        this.lastName = ret.attributes.lastName ?? "";
        this.feedbackMailStatus = ret.attributes.feedback_mail_status ?? "";
        this.lastFeedbackMailSentAt = ret.attributes.last_feedback_mail_sent_at ?? "";
      } else {
        this.username = ret.username;
        this.email = ret.email;
        this.confirmed = ret.confirmed;
        this.billingAddress = ret.billingAddress ?? "";
        this.role = ret.role;
        this.firstName = ret.firstName ?? "";
        this.lastName = ret.lastName ?? "";
        this.feedbackMailStatus = ret.feedback_mail_status ?? "";
        this.lastFeedbackMailSentAt = ret.last_feedback_mail_sent_at ?? "";
      }
    }
  }

  toApiJSON() {
    const payload: Record<string, any> = {
      username: this.username,
      email: this.email,
      confirmed: this.confirmed,
      billingAddress: this.billingAddress,
      firstName: this.firstName,
      lastName: this.lastName,
      role: this.role?.id ?? this.role,
    };

    if (this.password && this.password !== "placeholder") {
      payload.password = this.password;
    }

    return payload;
  }

  toJSON() {
    return {
      id: this.id,
      username: this.username,
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      confirmed: this.confirmed,
      token: this.token,
      billingAddress: this.billingAddress,
      role: this.role,
    };
  }
}

export const userRoles = [
  {
    name: "Public",
    value: 2,
  },
  {
    name: "Customer",
    value: 3,
  },
  {
    name: "Authenticated",
    value: 1,
  },
];
